import { useState, useEffect } from 'react';
import { tokenManager } from '../config/authConfig';
import API_CIFRA from '../config/Variables_apis';

const useCategorias = () => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Función para obtener headers de autenticación
  const getAuthHeaders = () => {
    const token = tokenManager.getAccessToken();
    const headers = {
      "Content-Type": "application/json",
    };
    
    if (token && !tokenManager.isTokenExpired()) { 
      headers.Authorization = `Bearer ${token}`;
    }
    
    return headers;
  };

  // Función para manejar errores específicos
  const handleApiError = (error, response) => {
    let errorMessage = "Error al cargar las categorías";
    
    if (response?.status === 400) {
      errorMessage = "Datos inválidos.";
    } else if (response?.status === 401) {
      errorMessage = "Error de autenticación.";
    } else if (response?.status === 403) {
      errorMessage = "No tienes permisos para acceder a las categorías.";
    } else if (response?.status === 404) {
      errorMessage = "Categorías no encontradas.";
    } else if (response?.status === 500) {
      errorMessage = "Error interno del servidor.";
    }
    
    return errorMessage;
  };

  // Función para cargar categorías
  const cargarCategorias = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(API_CIFRA.categoria.listar, {
        method: 'GET',
        headers: getAuthHeaders(),
      });

      const data = await response.json();
      console.log('Respuesta del backend (categorías):', data);

      if (!response.ok) {
        const errorMessage = handleApiError(null, response);
        throw new Error(data.error || data.detail || errorMessage);
      }

      // Asegurar que data sea siempre un array
      let categoriasArray = [];
      
      if (Array.isArray(data)) {
        categoriasArray = data;
      } else if (data && typeof data === 'object') {
        // Si es un objeto, intentar extraer el array de categorías
        if (data.results && Array.isArray(data.results)) {
          categoriasArray = data.results;
        } else if (data.categorias && Array.isArray(data.categorias)) {
          categoriasArray = data.categorias;
        } else if (data.data && Array.isArray(data.data)) {
          categoriasArray = data.data;
        }
      }
      
      console.log('Categorías procesadas:', categoriasArray);
      setCategorias(categoriasArray);
      return { success: true, data: categoriasArray };

    } catch (error) {
      const errorMessage = error.message || "Error al cargar categorías";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  // Función para obtener categoría por ID
  const obtenerCategoriaPorId = (id) => {
    return categorias.find(cat => cat.cat_inId === id);
  };

  // Función para obtener categoría por nombre
  const obtenerCategoriaPorNombre = (nombre) => {
    return categorias.find(cat => cat.cat_chNombre === nombre);
  };

  // Cargar categorías al montar el componente
  useEffect(() => {
    cargarCategorias();
  }, []);

  return {
    // Estado
    categorias,
    loading,
    error,
    
    // Funciones
    cargarCategorias,
    obtenerCategoriaPorId,
    obtenerCategoriaPorNombre,
  };
};

export default useCategorias; 